import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { LedgerState } from "./type";
import { generateQueryString } from "../helper/helpers";

export const getLedgerRecord = createAsyncThunk(
  "web/get-ledger-record",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/ledger${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_LEDGER_RECORD(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getLedgerOverview = createAsyncThunk(
  "web/get-ledger-overview",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/ledger/overview${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_LEDGER_OVERVIEW(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getLedgerDetails = createAsyncThunk(
  "web/get-ledger-details",
  async (id: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/ledger/${id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_LEDGER_RECORD_ID(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const initialState: LedgerState = {
  loading: false,
  ledger_overview: {},
  ledger_record: {},
  ledger_record_id: {},
};

export const ledgertSlice = createSlice({
  name: "feature-management",
  initialState,
  reducers: {
    SET_LEDGER_RECORD: (state, action) => {
      state.ledger_record = action.payload;
    },
    SET_LEDGER_OVERVIEW: (state, action) => {
      state.ledger_overview = action.payload;
    },
    SET_LEDGER_RECORD_ID: (state, action) => {
      state.ledger_record_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLedgerRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLedgerRecord.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getLedgerRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getLedgerOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLedgerOverview.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getLedgerOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getLedgerDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLedgerDetails.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getLedgerDetails.rejected, (state) => {
        state.loading = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const { SET_LEDGER_RECORD, SET_LEDGER_OVERVIEW, SET_LEDGER_RECORD_ID } =
  ledgertSlice.actions;

export default ledgertSlice.reducer;
